import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerOrderSummaryByOrderID(orderId) {
  const response = await $.soap({
    body: {
      GetCustomerOrderSummaryByOrderID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderID: orderId
      }
    },
    blueprintArrays: [
      'GetCustomerOrderSummaryByOrderIDResponse.DevicesSummary.tuple',
      'GetCustomerOrderSummaryByOrderIDResponse.AccessoriesSummary.tuple',
      'GetCustomerOrderSummaryByOrderIDResponse.ServicesSummary.tuple'
    ],
    blueprint: {
      devicesSummary: [
        '$..DevicesSummary.tuple',
        {
          item: '$..Description',
          chargeFrequency: '$..ChargeFrequency',
          quantity: '$..Quantity',
          pricePerItem: '$..PricePerItem',
          totalPrice: '$..TotalPrice'
        }
      ],
      accessoriesSummary: [
        '$..AccessoriesSummary.tuple',
        {
          item: '$..Description',
          chargeFrequency: '$..ChargeFrequency',
          quantity: '$..Quantity',
          pricePerItem: '$..PricePerItem',
          totalPrice: '$..TotalPrice'
        }
      ],
      servicesSummary: [
        '$..ServicesSummary.tuple',
        {
          item: '$..Description',
          chargeFrequency: '$..ChargeFrequency',
          quantity: '$..Quantity',
          pricePerItem: '$..PricePerItem',
          totalPrice: '$..TotalPrice'
        }
      ],
      deviceTotalMonthlyCost: '$..Totals.DeviceTotalMonthlyCost',
      deviceTotalQuantity: '$..Totals.DeviceTotalQuantity',
      accessoriesTotalCost: '$..Totals.AccessoriesTotalCost',
      accessoriesQuantity: '$..Totals.AccessoriesQuantity',
      servicesTotalCost: '$..Totals.ServicesTotalCost',
      servicesQuantity: '$..Totals.ServicesQuantity',
      orderTotalsSummary: {
        oneTimeCharges: '$..Totals.OneTimeCharges',
        recurringMonthlyCost: '$..Totals.RecurringMonthlyCost',
        totalMiprAmount: '$..Totals.TotalMiprAmount',
        totalAnnualCost: '$..Totals.TotalAnnualCost',
        monthsUntilDateEquipmentReq: '$..Totals.MonthsUntilDateEquipmentReq'
      }
    }
  });

  cleanUpResponse(response);
  return response;
}
